import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import { Box, Stack } from '@mui/material';

import { styles } from './OverdueActionItemsBell.styles';

interface OverdueActionItemsBellProps {
  count: number;
}

const OverdueActionItemsBell: FC<OverdueActionItemsBellProps> = ({ count }) => {
  const { t } = useTranslation('survey');

  return (
    <Stack
      direction="column"
      title={`${count} ${t('overdueTickets')}`}
      sx={{
        justifyContent: 'center',
      }}
    >
      <Box sx={styles.notificationIconWrapper(count > 0)}>
        <NotificationsNoneOutlined sx={styles.notificationIcon} />
        <Box component="span" sx={styles.notificationDot(count > 0)} />
      </Box>
    </Stack>
  );
};

export default OverdueActionItemsBell;
